module.exports = __webpack_public_path__ + "img/portada2.71f4aceb.svg";